import {store} from '../Store/store'

class AdminService {
    static async getAdminsAsync(eventId:string, signal:AbortSignal){
        let response = await fetch(`${process.env.REACT_APP_EVENTX_TRACKER_API_URL}/EventAdminGet?eventId=${eventId}`,
            {
                method:'GET',
                mode:'cors',
                signal: signal,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Pragma': 'no-cache',
                    'Authorization': 'Bearer ' + store.getState().user.eventXTrackerToken,
                }
            }
        )
        if(response.status !== 200){ throw response }
        return await response.json()
    }

    static async addAdminAsync(data:any, signal:AbortSignal){
        let response = await fetch(`${process.env.REACT_APP_EVENTX_TRACKER_API_URL}/EventAdminAdd`,
            {
                method:'POST',
                mode:'cors',
                cache: 'no-cache',
                signal: signal,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Pragma': 'no-cache',
                    'Authorization': 'Bearer ' + store.getState().user.eventXTrackerToken,
                },
                body: JSON.stringify(data)
            }
        )
        if(response.status !== 200){ throw response }
        return await response.json()
    }

    
    static async removeAdminAsync(data:any, signal:AbortSignal){
        let response = await fetch(`${process.env.REACT_APP_EVENTX_TRACKER_API_URL}/EventAdminRemove?userId=${data.userId}&eventId=${data.eventId}`,
            {
                method:'DELETE',
                mode:'cors',
                cache: 'no-cache',
                signal: signal,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Pragma': 'no-cache',
                    'Authorization': 'Bearer ' + store.getState().user.eventXTrackerToken,
                },
            }
        )
        if(response.status !== 200){ throw response }
        return await response.text()
    }
}

export default AdminService